import React, { Component } from "react"
import {Dialog} from "./dialog"
import PropType from "prop-types"
import Button from "./button";

export default class AlertDialog extends Component {

    render(){
        return (
            <Dialog title={this.props.title} className={this.props.className} isOpen={this.props.isOpen} onClose={this.props.onOkAction}>
                <React.Fragment>
                    <br/>
                    <p>{this.props.message}</p>
                    <br/>
                    <div className="btn-dialog-container">
                        <Button buttonStyle="primary" className="btn-dialog" buttonLabel={this.props.okButtonLabel ? this.props.okButtonLabel : "OK"} onClick={()=>{this.props.onOkAction()}} />
                    </div>
                </React.Fragment>

            </Dialog>
        )
    }
}

AlertDialog.propTypes = {
    title: PropType.string.isRequired,
    message: PropType.any.isRequired,
    isOpen: PropType.bool.isRequired,
    okButtonLabel: PropType.string,
    onOkAction: PropType.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/common/components/alert-dialog.jsx